import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { BaseError } from 'helpers/BaseError';

import alternateKeys from 'hooks/alternates/_queryKeys';
import formulaKeys from 'hooks/formulas/_queryKeys';
import useGetCurrentMessageContent from 'hooks/message-content/useGetCurrentMessageContent';
import personalizationKeys from 'hooks/personalization/_queryKeys';

import { VarintUpdateRequest } from 'models/variant.model';

import API from '../../services/api';

const useVariantUpdate = (componentId: string, formulaId: number) => {
    const queryClient = useQueryClient();
    const { currentMessageContentId } = useGetCurrentMessageContent(formulaId);

    return useMutation<AxiosResponse, BaseError, VarintUpdateRequest>({
        mutationFn: ({ id, data }) => API.updateVariant(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: alternateKeys.getVariantsByMessageContentId(
                    currentMessageContentId as string,
                ),
            });
            queryClient.invalidateQueries({
                queryKey: alternateKeys.getVariantsByComponentId(componentId),
            });
            queryClient.invalidateQueries({
                queryKey: formulaKeys.formulaMessages(
                    formulaId,
                    currentMessageContentId,
                ),
            });
            queryClient.invalidateQueries({
                queryKey: personalizationKeys.personalizationMap,
            });
            queryClient.invalidateQueries({
                queryKey: personalizationKeys.getHeroRecommendations(),
            });
        },
    });
};

export default useVariantUpdate;
